import { administratorRoles } from "../../config/roles";
import { RecordDefinition } from "../recordDefinition.types";
import { opponentTypePageConfig } from "./opponentTypePageConfig";

export const opponentTypeRecordDefinition: RecordDefinition = {
  path: "/opponent-type",
  entityName: "dwopponenttype",
  listRoute: "/opponent-types",
  backTitle: "Back to opponent types",
  allowedRoles: administratorRoles,
  config: opponentTypePageConfig,
  // The warehouse holds this record, and the view resolver never sees it.
  authorable: false,
  identity: {
    titleFields: ["name"],
    fallbackTitle: "Opponent Type",
    newRecordTitle: "New Opponent Type",
  },
};
